module.exports = __webpack_public_path__ + "static/media/buildingSolid.215aafed.svg";